import ErrorManager from '@/common/utils/ErrorManager';
import { ERROR } from '@/modules/ErrorToaster/store/mutation-types';
import { RootState } from '@/plugins/store';
import { ActionTree } from 'vuex';
import { FactureFournisseurState } from '@/modules/FacturesFournisseurs/store/state';
import {
    FactureFournisseurActions,
    FactureFournisseurActionType
} from '@/modules/FacturesFournisseurs/store/action-types';
import { FACTURE_FOURNISSEUR } from '@/modules/FacturesFournisseurs/store/mutation-types';
import FactureService, { FilterFacturesFournisseur } from '@/modules/FacturesFournisseurs/services/FactureService';

export const actions: ActionTree<FactureFournisseurState, RootState> = {
    async [FactureFournisseurActions.GET_FACTURES](
        { commit }: FactureFournisseurActionType,
        payload: FilterFacturesFournisseur
    ): Promise<void> {
        commit(FACTURE_FOURNISSEUR.SET_FACTURES_LOADING, true);
        commit(FACTURE_FOURNISSEUR.SET_PAGE, payload.page);

        FactureService.getFacturesFournisseur(payload)
            .then(async (response: any) => {
                if (response !== undefined || response?.status !== undefined) {
                    if (response.status !== 200) {
                        commit(
                            `errorToaster/${ERROR.SET_MESSAGE}`,
                            await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                            { root: true }
                        );
                    }
                    if (payload.page === 0) {
                        commit(FACTURE_FOURNISSEUR.SET_FACTURES, response.data.content);
                        commit(FACTURE_FOURNISSEUR.SET_NUMBER_OF_PAGES, response.data.totalPages);
                        commit(FACTURE_FOURNISSEUR.SET_NB_ELEMENTS, response.data.totalElements);
                    } else {
                        commit(FACTURE_FOURNISSEUR.ADD_FACTURES, response.data.content);
                    }
                } else {
                    commit(
                        `errorToaster/${ERROR.SET_MESSAGE}`,
                        await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                        { root: true }
                    );
                }
                commit(FACTURE_FOURNISSEUR.SET_FACTURES_LOADING, false);
            })
            .catch(async error => {
                commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
                commit(FACTURE_FOURNISSEUR.SET_FACTURES_LOADING, false);
            });
    },
    async [FactureFournisseurActions.CONTACTER](
        { commit }: FactureFournisseurActionType,
        payload: { id: string | number; objet: string; sujet: string; isFactureRejetee?: boolean }
    ): Promise<void> {
        const id = typeof payload.id === 'string' ? payload.id : String(payload.id);

        (payload.isFactureRejetee
            ? FactureService.contacterComptaFournisseur(id, payload.objet, payload.sujet)
            : FactureService.contacter(id, payload.objet, payload.sujet)
        )
            .then(async (response: any) => {
                if (response?.status !== 200) {
                    commit(
                        `errorToaster/${ERROR.SET_MESSAGE}`,
                        await ErrorManager.processErrorCustomMessage(response?.status, 'app.error.undefined'),
                        { root: true }
                    );
                }
            })
            .catch(async error => {
                commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
            });
    },

    async [FactureFournisseurActions.GET_XLS](
        { commit }: FactureFournisseurActionType,
        payload: FilterFacturesFournisseur
    ): Promise<void> {
        commit(FACTURE_FOURNISSEUR.XLS_LOADING, true);
        try {
            const response = await FactureService.getFacturesXls(payload);
            if (response.status === 200 && response.data !== undefined) {
                const blob = new Blob([response.data], { type: response.headers['content-type'] });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'export_factures.xlsx';
                link.click();
                URL.revokeObjectURL(link.href);
            } else {
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                    { root: true }
                );
            }
            commit(FACTURE_FOURNISSEUR.XLS_LOADING, false);
        } catch (error) {
            commit(FACTURE_FOURNISSEUR.XLS_LOADING, false);
            commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
        }
    },
};
